/* istanbul ignore file */
import { boolean as codecBoolean, number as codecNumber, optional as codecOptional, string as codecString, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PutEnrollLinkCourseDataParser = 
/* #__PURE__ */ parsers.object([
    ['id', /* #__PURE__ */ codecOptional(codecString)],
    ['roleId', codecNumber, 'role_id'],
    ['expirationDate', parsers.moment, 'expiration_date'],
    ['allowRegister', /* #__PURE__ */ codecOptional(codecBoolean), 'allow_register'],
]);
export class PutEnrollLinkCourseData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PutEnrollLinkCourseDataParser.decode(input).map(res => new PutEnrollLinkCourseData(res));
    }
    static unsafeDecode(input) {
        return PutEnrollLinkCourseData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PutEnrollLinkCourseDataParser.encode(data);
    }
    static schema() {
        return PutEnrollLinkCourseDataParser.schema();
    }
}
